import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X, Home, Info, Cpu, User } from 'lucide-react';
import { useAuthenticator } from '@aws-amplify/ui-react';

const MobileNav = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { authStatus } = useAuthenticator(context => [context.user, context.authStatus]);
  const isAuthenticated = authStatus === 'authenticated';

  const navLinks = [
    { name: 'Home', path: '/', icon: Home },
    { name: 'ICE', path: '/ice', icon: Cpu },
    { name: 'GoingMerry', path: '/goingmerry', icon: Cpu },
    { name: 'About', path: '/contact', icon: Info },
  ];

  if (isAuthenticated) {
    navLinks.push({ name: 'Profile', path: '/profile', icon: User });
  }

  return (
    <div 
      className={`fixed inset-0 z-[200] lg:hidden transition-[opacity] duration-300 ${
        isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}
    >
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Sidebar */}
      <div 
        className={`absolute inset-y-0 left-0 w-72 bg-[#191d2b] shadow-2xl border-r border-slate-800 transition-[transform] duration-300 ease-out z-[210] ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full p-6">
          <div className="flex items-center justify-between mb-10">
            <Link to="/" onClick={onClose} className="flex items-center space-x-3">
              <img src="/logo_trans_1x1_white.png" alt="DOPOVE Logo" className="h-8 w-auto" />
              <span className="text-xl font-bold text-white tracking-tight">DOPOVE</span>
            </Link>
            <button onClick={onClose} className="p-2 hover:bg-slate-800 rounded-full text-slate-400 hover:text-white transition-colors">
              <X size={24} />
            </button>
          </div>

          <nav className="flex-grow space-y-2">
            {navLinks.map((link) => (
              link.isExternal ? (
                <a
                  key={link.path}
                  href={link.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={onClose}
                  className="flex items-center space-x-4 px-4 py-3 rounded-xl hover-lift focus-visible-ring transition-[background-color,color] duration-200 ease-[var(--ease-out)] text-slate-400 hover:bg-slate-800/50 hover:text-white"
                >
                  <link.icon size={20} />
                  <span className="uppercase tracking-widest text-sm">{link.name}</span>
                </a>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={onClose}
                  className={`flex items-center space-x-4 px-4 py-3 rounded-xl hover-lift focus-visible-ring transition-[background-color,color] duration-200 ease-[var(--ease-out)] ${
                    location.pathname === link.path 
                      ? 'bg-blue-600/10 text-blue-400 font-bold' 
                      : 'text-slate-400 hover:bg-slate-800/50 hover:text-white'
                  }`}
                >
                  <link.icon size={20} />
                  <span className="uppercase tracking-widest text-sm">{link.name}</span>
                </Link>
              )
            ))}
          </nav>

          <div className="mt-auto pt-6 border-t border-slate-800">
            {!isAuthenticated && (
              <Link
                to="/auth?state=signIn"
                onClick={onClose}
                className="w-full py-4 bg-[#323639] text-[#f4f0e9] rounded-xl flex items-center justify-center font-bold uppercase tracking-widest text-xs border border-slate-700/50 hover-scale-press focus-visible-ring transition-[background-color,border-color,transform] duration-200 ease-[var(--ease-out)]"
              >
                Sign In
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;